
import styles from './index.module.scss'
import GoBack from "../components/GoBack"
import { useState, useContext, useMemo, useEffect, useRef } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { EditOutlined, CloseOutlined } from '@ant-design/icons';
import { Button, Modal, Popover } from 'antd';
import Iconfont from '@utils/Iconfont';
import Utils from '@utils/utils';
import API from "@api/api";
import usePickedImageList from './usePickedImageList';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PictureViewModal from '../components/PictureViewModal'
import { DISPLAY_TYPE, BATCH_IMAGES_TYPE } from '@utils/CONST'
import usePickedImageDownload from './usePickedImageDownload'
import { BatchImagesContext } from '../BatchImagesContext'
import PSAIModal from '@PSAIComponents/PSAIModal';
import { AppContext } from '@utils/AppContext';
import BottomBtnGroups from '../components/BottomBtnGroups'

const ResultsPage = (props) => {
    const navigate = useNavigate()
    const { globalUser } = useContext(AppContext)
    const { setSelectSkuId } = useContext(BatchImagesContext)
    const { projectId } = useParams()
    const [skuList, setSkuList] = useState([])
    const [projectName, setProjectName] = useState('')
    const [submitConfigVisible, setSubmitConfigVisible] = useState(false)
    const [createLoading, setCreateLoading] = useState(false)
    const [handleNumber, setHandleNumber] = useState(4)

    useEffect(() => {
        if (!projectId) return
        batchListSkuCoverList()
    }, [projectId])

    // 生成页面左侧SKU列表
    const batchListSkuCoverList = () => {
        API.batchListSkuCoverList({
            projectId: projectId
        }).then(res => {
            if (res.code === 0) {
                const newSkuList = res.data?.skuDetailList || []
                setSkuList(newSkuList || [])
                setActiveSku(newSkuList?.[0]?.skuId || '')
                setProjectName(res.data?.projectName || '')
            } else if (res?.code == -5003) {
                navigate("/home/product/batchImages")
                message.error(res.message)
            }
        })
    }

    // 取选图列表
    const { pickedList, groupedPickedList, pickedCount, refreshPickedList } = usePickedImageList(projectId, projectName)

    // 下载选中图
    const { handleDownload, downLoading } = usePickedImageDownload(projectId)


    // ============= 🔹 核心逻辑：滚动绑定 =============
    const groupRefs = useRef({}) // 保存右侧每个 skuId 对应的 div
    const rightBoxRef = useRef(null)
    const [activeSku, setActiveSku] = useState(null)

    const handleScrollToSku = (skuId) => {
        setActiveSku(skuId);
        const rightBox = rightBoxRef.current;
        const target = groupRefs.current[skuId];
        if (rightBox && target) {
            const offsetTop = target.offsetTop - rightBox.offsetTop;

            rightBox.scrollTo({
                top: offsetTop,
                behavior: "smooth",
            });
        }
    }

    // 大图弹窗
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [item, setItem] = useState()
    const [taskId, setTaskId] = useState()
    const [modalOpenFlag, setModalOpenFlag] = useState(false)
    const modalRef = useRef(null)
    useEffect(() => {
        if (!isModalOpen) {
            setTaskId()
            setItem()
        }
    }, [isModalOpen])
    const handleCLick = (item) => {
        if (item.status != "succeeded") return
        setItem(item)
        setTaskId(item?.taskId)
    }
    useEffect(() => {
        if (item && taskId) {
            setIsModalOpen(true)
        }
    }, [item, taskId])

    const goSelect = (skuId) => {
        setSelectSkuId(skuId)
        navigate(`/home/product/${projectId}/detail`)
    }

    const batchDoImageFiner = () => {
        if (pickedCount > Number(globalUser?.membership?.concurrentSku || 50)) {
            PSAIModal.confirm({
                title: `提示`,
                content: `您发起的任务数已超过当前套餐的单次任务上限，将为您分为${Math.ceil(pickedCount / Number(globalUser?.membership?.concurrentSku || 50))}个项目发起。确认后将跳转至企业版首页，可在对应项目内查看。`,
                okText: "确认",
                cancelText: null,
                onOk() { setSubmitConfigVisible(true) },
                onCancel() { }
            })
        } else {
            setSubmitConfigVisible(true)
        }
    }

    const handleSubmitConfig = () => {
        setCreateLoading(true)
        API.batchDoImageFiner({
            projectId,
            num: handleNumber,
        }).then(res => {
            if (res?.code == 0) {
                if (res.data?.length === 1) {
                    navigate(`/home/product/${res.data[0]}/detail`)
                } else if (res.data?.length > 1) {
                    navigate(`/home/myProject/batchImages`)
                }
            } else throw new Error(res.message)
        }).finally(() => {
            setCreateLoading(false)
        })

    }

    const DownloadMenuContent = () => (
        <div className={styles.DownloadMenu}>
            <p onClick={() => handleDownload(false)}>按商品分文件下载</p>
            <p onClick={() => handleDownload(true)}>所有图片在一个文件夹内</p>
        </div>
    )

    return (
        <>
            <div className={styles.SelectedPage}>
                <div className={styles.ResultsPageWrap}>
                    <div className={styles.GoBack}>
                        <GoBack onClick={() => navigate(`/home/product/${projectId}/detail`)} />
                        <span className={styles.TaskTitle}>查看已选图</span>
                    </div>
                    <div className={styles.ResultsBox}>
                        <div className={`${styles.ResultsBoxLeft} _beauty_scrollbar`}>
                            {skuList?.map((item) => (
                                <div
                                    key={item.skuId}
                                    className={`${styles.ImageItem} ${activeSku === item.skuId ? styles.active : ""}`}
                                    onClick={() => handleScrollToSku(item.skuId)}
                                >
                                    <img src={Utils.getImgThumbnail(item.cover)} alt="" />
                                </div>
                            ))}
                        </div>
                        <div ref={rightBoxRef} className={`${styles.ResultsBoxRight} _beauty_scrollbar`}>
                            {
                                groupedPickedList?.map((item) => (
                                    item?.[0]?.picked ? <div
                                        ref={(el) => groupRefs.current[item?.[0]?.skuId] = el}
                                        className={`${styles.groupWrap} ${item?.[0]?.projectType == BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? styles.groupWrapBatch : ''}`} key={item?.[0]?.skuId}>
                                        <p>商品ID：{item?.[0]?.taskSerial}（已选择{skuList.filter(sku => sku.skuId == item?.[0]?.skuId)[0]?.pickedNum || 0}张）</p>
                                        {
                                            item?.flatMap((imgItem) =>
                                                imgItem?.results?.map((result, resultIndex) => (
                                                    <div className={styles.groupWrapItemImg} onClick={() => handleCLick(imgItem)} key={`${imgItem?.taskId}-${resultIndex}`}>
                                                        <LazyLoadImage
                                                            alt={`example-${resultIndex}`}
                                                            effect="blur"
                                                            src={Utils.getImgThumbnail(result?.image)}
                                                            placeholderSrc={Utils.getImgThumbnail(result?.image)}
                                                        />
                                                        <BottomBtnGroups isSelectPage={true} item={imgItem} className={styles.hideOnNormal} />
                                                    </div>
                                                )) || []
                                            )
                                        }
                                    </div> : <div ref={(el) => groupRefs.current[item?.[0]?.skuId] = el} className={styles.groupWrap} key={item?.[0]?.skuId}>
                                        <p>商品待选：{item?.[0]?.taskSerial}（已选择0张）</p>
                                        <div className={styles.groupWrapItemImgNull}>
                                            <div style={{ width: '100%' }}>
                                                <Iconfont className={styles.Icon} type="icon-newProjectOutlined" />
                                                <Button className={styles.GoSelectBtn} onClick={() => goSelect(item?.[0]?.skuId)}>去选图</Button>
                                            </div>
                                        </div>
                                    </div>

                                ))
                            }
                            {
                                pickedList.length > 0 && pickedList?.filter(item => item?.projectType == BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH).length === 0 &&
                                <Button type="primary"
                                    className={styles.ViewSelectedBtn2}
                                    onClick={() => batchDoImageFiner()}>发起超清任务</Button>
                            }
                            <Popover
                                placement="top"
                                content={DownloadMenuContent}
                                arrow={false}
                                styles={{ body: { borderRadius: '12px', padding: 0 } }}
                            >
                                <Button type="primary"
                                    loading={downLoading}
                                    disabled={downLoading}
                                    className={styles.ViewSelectedBtn}>
                                    下载全部已选图（{pickedCount}张）</Button>
                            </Popover>

                        </div>
                    </div>
                </div>
            </div>
            <Modal
                open={isModalOpen}
                onOk={() => setIsModalOpen(false)}
                footer={null}
                maskClosable={true}
                width="100%"
                style={{ top: 0, padding: 0, margin: 0, maxWidth: '100vw', height: '100vh' }}
                bodyStyle={{ height: '100vh', overflow: 'hidden' }}
                destroyOnHidden
                onCancel={() => setIsModalOpen(false)}
                className='PictureViewModal'
                afterOpenChange={(open) => setModalOpenFlag(open)}
                closeIcon={false}
            >
                <PictureViewModal
                    modalOpenFlag={modalOpenFlag}
                    isSelectPage={true} //是否是调图页
                    displayType={DISPLAY_TYPE.PROJECT}
                    setProjectId={() => null}
                    ref={modalRef}
                    taskId={taskId}
                    setTaskId={setTaskId}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    item={item}
                    setItem={setItem}
                    groupedTasks={groupedPickedList}
                    fetchProjectDetail={refreshPickedList} />
            </Modal>
            <PSAIModal
                title='设置生图参数'
                maxWidth={564}
                okText={'确定'}
                open={submitConfigVisible}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: createLoading }}
                onCancel={() => setSubmitConfigVisible(false)}
                onOk={() => handleSubmitConfig()}
            >
                <div className={styles.submitConfigWrap}>
                    {
                        <div className={styles.submitConfigItem}>
                            <span>每张参考图生成数量</span>
                            <p>{
                                Array.from({ length: 4 }).map((_, i) => <span className={handleNumber == i + 1 ? styles.active : ''} onClick={() => setHandleNumber(i + 1)} key={i}>{i + 1}张</span>)
                            }</p>
                        </div>
                    }
                    <div className={styles.submitConfigBottom}>
                        <p>预计消耗<img style={{ margin: '0 12px', width: '32px', height: '32px' }} src={require('@assets/images/arcbean3.png')} alt="" />
                            <span className={styles.arcbean}>{pickedCount * handleNumber * 10}</span></p>
                        <p>源素材{pickedCount}张*每张源素材图生成{handleNumber}张* 10虹豆</p>
                    </div>
                </div>
            </PSAIModal>
        </>

    )
}

export default ResultsPage